import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18def2eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "range" }
const _hoisted_2 = { class: "container" }

import { ref, watch, onMounted } from 'vue'

const minGap = 0
const sliderMaxValue = 31


export default /*#__PURE__*/_defineComponent({
  __name: 'MyDoubleRange',
  props: {
    startValue: {},
    endValue: {},
    updateValues: { type: Function }
  },
  setup(__props: any) {

const props = __props

const sliderOneValue = ref(props.startValue ?? 0)
const sliderTwoValue = ref(props.endValue ?? 0)
const sliderTrack = ref<HTMLDivElement | null>(null)
const resultRange1 = ref<HTMLDivElement | null>(null)
const resultRange2 = ref<HTMLDivElement | null>(null)
const getCompensation = (value: number): number => {
  switch (value) {
    case 0:
    case 1:
    case 2:
      return 11
    case 3:
      return 10
    case 4:
      return 9
    case 5:
      return 8
    case 6:
    case 7:
      return 7
    case 8:
      return 6
    case 9:
    case 10:
      return 5
    case 11:
      return 4
    case 12:
    case 13:
      return 3
    case 14:
      return 2
    case 15:
      return 1
    case 16:
    case 17:
      return 0
    case 18:
      return -1
    case 19:
      return -2
    case 20:
      return -3
    case 21:
      return -3
    case 22:
      return -4
    case 23:
    case 24:
      return -5
    case 25:
      return -6
    case 26:
    case 27:
      return -7
    case 28:
      return -8
    case 29:
      return -9
    case 30:
    case 31:
      return -10
    default:
      return 0
  }
}

const displayValues = () => {
  if (sliderTrack.value) {
    const percent1 = (sliderOneValue.value / sliderMaxValue) * 100
    const percent2 = (sliderTwoValue.value / sliderMaxValue) * 100
    sliderTrack.value.style.background = `linear-gradient(to right, #F1F1F1 ${percent1}%, #079F72 ${percent1}%, #079F72 ${percent2}%, #F1F1F1 ${percent2}%)`

    if (resultRange1.value && resultRange2.value) {
      const leftOffset1 = getCompensation(sliderOneValue.value)
      const leftOffset2 = getCompensation(sliderTwoValue.value)

      resultRange1.value.style.left = `calc(${percent1}% - ${resultRange1.value.offsetWidth / 2}px + ${leftOffset1}px)`
      resultRange2.value.style.left = `calc(${percent2}% - ${resultRange2.value.offsetWidth / 2}px + ${leftOffset2}px)`
    }
  }
}

const ensureRangeValidity = () => {
  if (sliderOneValue.value > sliderTwoValue.value) {
    sliderOneValue.value = sliderTwoValue.value
  } else if (sliderTwoValue.value < sliderOneValue.value) {
    sliderTwoValue.value = sliderOneValue.value
  }
}

const updateParentValues = () => {
  if(sliderOneValue.value == 0 && sliderTwoValue.value != 0){
    sliderOneValue.value = 1;
  }
  ensureRangeValidity()
  props.updateValues(sliderOneValue.value, sliderTwoValue.value)
  displayValues()
}

watch(sliderOneValue, updateParentValues)
watch(sliderTwoValue, updateParentValues)

onMounted(() => {
  displayValues()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      id: "range1",
      ref_key: "resultRange1",
      ref: resultRange1
    }, _toDisplayString(sliderOneValue.value), 513),
    _createElementVNode("p", {
      id: "range2",
      ref_key: "resultRange2",
      ref: resultRange2
    }, _toDisplayString(sliderTwoValue.value), 513),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "slider-track",
        ref_key: "sliderTrack",
        ref: sliderTrack
      }, null, 512),
      _withDirectives(_createElementVNode("input", {
        type: "range",
        min: "0",
        max: "31",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sliderOneValue).value = $event)),
        onInput: updateParentValues,
        ref: "sliderOne"
      }, null, 544), [
        [
          _vModelText,
          sliderOneValue.value,
          void 0,
          { number: true }
        ]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "range",
        min: "0",
        max: "31",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sliderTwoValue).value = $event)),
        onInput: updateParentValues,
        ref: "sliderTwo"
      }, null, 544), [
        [
          _vModelText,
          sliderTwoValue.value,
          void 0,
          { number: true }
        ]
      ])
    ])
  ]))
}
}

})